import { FC } from 'react';
import {
  Box,
  SxProps, Theme
} from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import YouTubeIcon from '@mui/icons-material/YouTube';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import { EnSocialMediaType } from 'src/api/dto/socialmedia/enSocialMediaType';
import PhoneIcon from '@mui/icons-material/Phone';
import EmailIcon from '@mui/icons-material/Email';
import PinterestIcon from '@mui/icons-material/Pinterest';
import XIcon from '@mui/icons-material/X';
import LinkIcon from '@mui/icons-material/Link';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import TelegramIcon from '@mui/icons-material/Telegram';
import PublicIcon from '@mui/icons-material/Public';

export interface SocialMediaIconsProps {
  icon: EnSocialMediaType;
  sx?: SxProps<Theme>;
  colorCode?: string;
}

const SocialMediaIcons: FC<SocialMediaIconsProps> = (props) => {
  const { icon, sx, colorCode } = props;

  const resolvedColor = colorCode || 'primary.main';

  return (
    <Box sx={{ ...sx, mt: 1 }}>
      {icon === EnSocialMediaType.Facebook && (
      <FacebookIcon sx={{ color: '#1877F2' }} />
      )}
      {icon === EnSocialMediaType.Instagram && (
      <InstagramIcon sx={{ color: '#E4405F' }} />
      )}
      {icon === EnSocialMediaType.Youtube && (
      <YouTubeIcon sx={{ color: '#FF0000' }} />
      )}
      {icon === EnSocialMediaType.LinkedIn && (
      <LinkedInIcon sx={{ color: '#0A66C2' }} />
      )}
      {icon === EnSocialMediaType.Phone && (
      <PhoneIcon sx={{ color: resolvedColor }} />
      )}
      {icon === EnSocialMediaType.Email && (
      <EmailIcon sx={{ color: resolvedColor }} />
      )}
      {icon === EnSocialMediaType.Pinterest && (
      <PinterestIcon sx={{ color: '#E60023' }} />
      )}
      {icon === EnSocialMediaType.Twitter && (
      <XIcon sx={{ color: '#000000' }} />
      )}
      {icon === EnSocialMediaType.Whatsapp && (
      <WhatsAppIcon sx={{ color: '#25D366' }} />
      )}
      {icon === EnSocialMediaType.Telegram && (
      <TelegramIcon sx={{ color: '#0088CC' }} />
      )}
      {icon === EnSocialMediaType.Snapchat && (
      <LinkIcon sx={{ color: '#FFFC00' }} />
      )}
      {icon === EnSocialMediaType.TikTok && (
      <LinkIcon sx={{ color: '#000000' }} />
      )}
      {icon === EnSocialMediaType.Discord && (
      <LinkIcon sx={{ color: '#5865F2' }} />
      )}
      {(icon === EnSocialMediaType.Website || icon === EnSocialMediaType.WKO) && (
      <PublicIcon sx={{ color: resolvedColor }} />
      )}
    </Box>
  );
};

export default SocialMediaIcons;
